import styled from 'styled-components';
import { Ribbon } from 'components/Offer/Styles';
import freeRibbon from 'assets/offer/freeRibbon.png';
import check from 'assets/offer/check.png';

export const FreeRibbon = styled(Ribbon)`
  background: url(${freeRibbon}) no-repeat;
  background-size: contain;
  width: 115px;
  height: 48px;
`;

export const FreeRibbonText = styled.span`
  color: #9b220f;
  font-size: 1.4em;
  font-weight: 800;
  text-transform: uppercase;
`;

export const CheckIcon = styled.img.attrs(() => ({
  src: check,
}))`
  position: absolute;
  top: 115px;
  right: 186px;
  width: 40px;
  height: 40px;
  @media (max-width: 1015px) {
    right: 160px;
  }
`;

export const DailyBonusContainer = styled.div`
  padding: 1rem;
`;

export const TimerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  font-weight: 800;
  padding-bottom: 2rem;
`;

export const Timer = styled.div`
  color: #ffffff;
  background-color: #f0255d;
  padding: 0.5rem 3rem;
  border-radius: 5rem;
  font-weight: 800;
  letter-spacing: 0.1rem;
`;
